export const quickViewButtons = [
    {
        key: 'front',
        label: 'Front',
    },
    {
        key: 'left',
        label: 'Left',
    },
    {
        key: 'right',
        label: 'Right',
    },
    {
        key: 'top',
        label: 'Top',
    },
    {
        key: 'bottom',
        label: 'Bottom',
    },
    {
        key: 'behind',
        label: 'Behind',
    },
];

export const scanTypeButtons = [
    'stl',
    'ply',
];

export function getScanDisplayName(scan, fallbackLabel) {
    return scan.alternateName || scan.displayLabel || scan.label || fallbackLabel;
}

export function getSceneModelId(scan, index) {
    return String(scan.id ?? `${scan.dentalCaseId || 'scan'}:${scan.displayIndex ?? index}`);
}

export function getSceneVariantId(scanId, scanType) {
    return `${scanId}:${scanType}`;
}

export function getAvailableScanTypes(scan) {
    return [
        scan.stlUrl && 'stl',
        scan.plyUrl && 'ply',
    ].filter(Boolean);
}

export function getDefaultScanType(scan) {
    if (scan.plyUrl) {
        return 'ply';
    }

    if (scan.stlUrl) {
        return 'stl';
    }

    return null;
}

export function getEffectiveScanType(scan, globalScanType) {
    if (globalScanType === 'ply' && scan.plyUrl) {
        return 'ply';
    }

    if (globalScanType === 'stl' && scan.stlUrl) {
        return 'stl';
    }

    return getDefaultScanType(scan);
}

export function resolveSceneSource(scan, scanType) {
    if (scanType === 'ply' && scan.plyUrl) {
        return {
            format: 'ply',
            geometryUrl: scan.plyUrl,
        };
    }

    if (scanType === 'stl' && scan.stlUrl) {
        return {
            format: 'stl',
            geometryUrl: scan.stlUrl,
        };
    }

    return null;
}

export function buildSceneModel(scan, index, scanType, shouldBuild) {
    const scanId = getSceneModelId(scan, index);
    const resolvedSource = resolveSceneSource(scan, scanType);

    if (!resolvedSource) {
        return null;
    }

    const preservePlacement = scan.preservePlacement ?? true;
    const textureUrl = resolvedSource.format === 'ply' ? (scan.textureUrl || null) : null;

    return {
        descriptorKey: [
            resolvedSource.format,
            resolvedSource.geometryUrl,
            textureUrl || '',
            preservePlacement ? '1' : '0',
        ].join(':'),
        format: resolvedSource.format,
        geometryUrl: resolvedSource.geometryUrl,
        id: getSceneVariantId(scanId, scanType),
        label: getScanDisplayName(scan, `View ${index + 1}`),
        preservePlacement,
        scanId,
        shouldBuild,
        textureUrl,
    };
}

export function areIdsEqual(leftIds, rightIds) {
    return leftIds.length === rightIds.length
        && leftIds.every((id, index) => id === rightIds[index]);
}

export function reconcileIds(currentIds, nextIds) {
    const dedupedIds = Array.from(new Set(nextIds));

    return areIdsEqual(currentIds, dedupedIds) ? currentIds : dedupedIds;
}

export function reconcileRequestedVariantIds(currentRequestedVariantIds, availableVariantIds, activeVariantIds) {
    const availableVariantIdSet = new Set(availableVariantIds);
    const nextRequestedVariantIds = currentRequestedVariantIds
        .filter((variantId) => availableVariantIdSet.has(variantId));

    activeVariantIds.forEach((variantId) => {
        nextRequestedVariantIds.push(variantId);
    });

    return reconcileIds(currentRequestedVariantIds, nextRequestedVariantIds);
}

export function getModelToggleState(visibleSwitchableEntries, globalScanType) {
    if (visibleSwitchableEntries.length === 0) {
        return 'disabled';
    }

    return globalScanType;
}

export function isRuntimeStateFailed(runtimeState) {
    return runtimeState?.renderStatus === 'failed' || runtimeState?.geometryStatus === 'failed';
}
